import Form from '../Form';
import Logo from '../Logo';
import Footer from '../Footer';

const { Grid, withStyles, Card, LinearProgress } = window.Material;
import './App.scss';
import { Reducer } from '../../reducers';

interface AppProps {
  classes: any;
  redirecting: boolean;
}
const styles = (theme: any) => ({
  root: {
    minWidth: '320px',
    // display: 'flex',
    // justifyContent: 'center',
    // flexDirection: 'column',
    // alignItems: 'center',
    //IE compatibility, used instead of above.
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  card: {
    borderRadius: '8px',
    backgroundColor: 'white',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    width: '450px',
    minWidth: '320px',
    padding: '21px 64px 34px',
    boxSizing: 'border-box',
    margin: 'auto',
  },
  progress: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
});

class App extends React.PureComponent<AppProps, {}> {
  render() {
    const { classes, redirecting } = this.props;
    return (
      <React.Fragment>
        <Grid container className={classes.root}>
          <Card className={classes.card} item>
            <Logo />
            <Form />
          </Card>
          <Footer />
          {redirecting && <LinearProgress className={classes.progress} />}
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  redirecting: state.login.redirecting,
});

export default window.reactRedux.connect(mapStateToProps, null)(withStyles(styles)(App));
